import { Box, Typography } from "@outschool/backpack";
import { faTimes } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { IconButton } from "@outschool/ui-legacy-component-library";
import React from "react";

import PageModal from "../PageModal";
import { PublicReviewsByParentInfiniteScroll } from "./PublicReviewsByParentInfiniteScroll";

type PublicReviewsByParentModalProps = {
  parentUid: string;
  isReviewModalOpen: boolean;
  setIsReviewModalOpen: (val: boolean) => void;
};

export const PublicReviewsByParentModal: React.FunctionComponent<
  PublicReviewsByParentModalProps
> = ({ parentUid, isReviewModalOpen, setIsReviewModalOpen }) => {
  return (
    <PageModal
      open={isReviewModalOpen}
      onClose={() => setIsReviewModalOpen(false)}
      sx={{
        height: "90vh",
        position: "relative",
        padding: "0px",
      }}
      hasCloseButton={false}
    >
      <Box
        sx={{
          height: "100%",
          paddingX: "24px",
          paddingBottom: "0px",
          overflowY: "auto",
          paddingTop: "105px",
        }}
      >
        <PublicReviewsByParentModalHeader
          setIsReviewModalOpen={setIsReviewModalOpen}
        />
        <PublicReviewsByParentInfiniteScroll parentUid={parentUid} />
      </Box>
    </PageModal>
  );
};

type PublicReviewsByParentModalHeaderProps = {
  setIsReviewModalOpen: PublicReviewsByParentModalProps["setIsReviewModalOpen"];
};

const PublicReviewsByParentModalHeader: React.FunctionComponent<
  PublicReviewsByParentModalHeaderProps
> = ({ setIsReviewModalOpen }) => {
  const { t } = useTranslation(
    "client\\components\\reviews\\PublicReviewsByParentModal",
  );
  return (
    <Box
      sx={{
        background: "white",
        paddingBottom: "20px",
        borderRadius: "0.5em",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        paddingX: "24px",
        paddingTop: "24px",
        zIndex: 2001,
      }}
    >
      <Typography variant="h3">{t("Reviews")}</Typography>

      <Box
        sx={{
          position: "absolute",
          top: "0.5em",
          right: "0.5em",
          zIndex: 1,
        }}
      >
        <IconButton
          icon={faTimes}
          iconProps={{ sx: { fontSize: "1.333em" } }}
          onClick={() => setIsReviewModalOpen(false)}
          aria-label={t("Close")}
        />
      </Box>
    </Box>
  );
};
